const kmToSM = (km: any, distanceIn: any) => {
  if (distanceIn === `mi`) {
    return km * 0.621371;
  }
  return km;
};

const SMToKm = (sm: any, distanceIn: any) => {
  if (distanceIn === `mi`) {
    return sm / 0.621371;
  }
  return sm;
};

export { kmToSM, SMToKm };
